<template>
  <v-container fill-height justify-center v-if="progress">
    <div class="text-center">
      <v-progress-circular
        :rotate="2"
        :size="100"
        :width="10"
        color="primary"
        indeterminate
      >
      </v-progress-circular>
    </div>
  </v-container>
  <v-container fluid fill-height v-else>
    <v-layout justify-center row pa-5>
      <v-flex xs12 sm10 md6>
        <v-form>
          <v-text-field
            label="ค้นหาโครงการ"
            v-model="searchText"
            placeholder="LPark... หรือ พระราม 3...."
            outlined
            autofocus
          ></v-text-field>
        </v-form>
        <v-card
          v-for="project in filteredProject"
          :key="project.NT_RUNNO"
          @click="projectSelect(project)"
          class="my-3"
          style="border-left: solid 5px #0045af; background: #e9eaeb"
        >
          <v-card-title
            ><b>{{ project.NT_CODE }}</b></v-card-title
          >
          <v-card-text>{{ project.NT_TNAME }}</v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from '@/axios';
import EventBus from '@/EventBus';

export default {
  name: 'ProjectSelect',
  data() {
    return {
      username: this.getLocalItem().user_id,
      projects: [],
      searchText: '',
      progress: true
    };
  },
  mounted() {
    window.location.href = 'https://parcel-int-mweb-prod.lpp.co.th/';
    // this.logout()
    window.scrollTo(0, 0);
    this.getProject();
    EventBus.$emit('set_navigation', { title: 'เลือกโครงการ' });

    let localItem = this.getLocalItem();
    // localItem.user_id = 'Piampawan'
    delete localItem.itemSelected;
    delete localItem.itemsParcel;
    delete localItem.searchText;
    delete localItem.nt_runno;
    delete localItem.nt_code;
    delete localItem.nt_tname;
    delete localItem.barcode;
    delete localItem.role;
    localStorage.setItem('parcel', JSON.stringify(localItem));

    EventBus.$emit('setNtCode', { nt_code: localItem.NT_CODE });
  },
  methods: {
    async getProject() {
      try {
        axios.post('/GetProject', { username: this.username }).then((res) => {
          // console.log('getProject', res.data.data)
          this.projects = res.data.data;
          const localItem = this.getLocalItem();
          localItem.role = res.data.role;
          localStorage.setItem('parcel', JSON.stringify(localItem));
          this.progress = false;
        });
      } catch (err) {
        console.log(err.message);
      }
    },
    projectSelect(project) {
      if (project) {
        const blockedNT = [
          'JO0411',
          'J851',
          'J611',
          'J531',
          'JO0731',
          'JC11311',
          'J361',
          'J301',
          'JC0991',
          'UO72',
          '807021',
          'JO1051',
          'J73101',
          'J73102',
          'J73103',
          'JC10511',
          '818011',
          'JO0431',
          'J540',
          'J372',
          'J681',
          'J5701',
          '5701-B',
          '5701-C',
          'J561',
          'J7222',
          'J722',
          'J461',
          'J411',
          'J412',
          'J091',
          'JO0561',
          'JO0231',
          'JG071',
          'JO1111',
          'JF7411',
          'J631'
        ];
        if (blockedNT.includes(project.NT_RUNNO)) {
          window.location.href = 'https://parcel-int-mweb-prod.lpp.co.th/';
        } else {
          const localItem = this.getLocalItem();
          localItem.nt_runno = project.NT_RUNNO;
          localItem.nt_code = project.NT_CODE;
          localItem.nt_tname = project.NT_TNAME;

          localStorage.setItem('parcel', JSON.stringify(localItem));
          EventBus.$emit('setNtCode', { nt_code: project.NT_CODE });
          this.$router.push('main-menu');
        }
      }
    }
  },
  computed: {
    filteredProject() {
      let result = [];
      let resultTmp1 = [];
      let resultTmp2 = [];
      let resultTmp3 = [];
      if (this.searchText) {
        resultTmp1 = this.filterObject(
          this.projects,
          'NT_RUNNO',
          this.searchText
        );
        resultTmp2 = this.filterObject(
          this.projects,
          'NT_CODE',
          this.searchText
        );
        resultTmp3 = this.filterObject(
          this.projects,
          'NT_TNAME',
          this.searchText
        );
        result = this.$_.sortBy(
          this.removeDuplicateObject(resultTmp1.concat(resultTmp2, resultTmp3)),
          'NT_CODE'
        );
      } else {
        result = this.$_.sortBy(this.projects, 'NT_CODE');
      }

      return result;
    }
  }
};
</script>

<style scoped>
.v-card__text {
  padding: 16px;
  font-size: 14px;
}

.v-card__title {
  padding: 16px 16px 8px;
  font-size: 22px;
}
</style>
